var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm._value),function(member,index){return _c('el-tag',{key:index + '_member',staticClass:"member-item",attrs:{"type":"primary","closable":"","size":"mini"},on:{"close":function($event){return _vm.removeMemberItem(index)}}},[_vm._v("\n    "+_vm._s(member.name)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }